import { createSlice } from '@reduxjs/toolkit';
import { stat } from 'fs';
import { ActivityState, Activity, ActivityEdge, ActivityNode } from '../../../types'


const initialState: ActivityState = {
    activityList: []
}

const haberlerSlice = createSlice({
    name: 'haberler',
    initialState,
    reducers: {
        setHaberler(state, action: { payload: ActivityEdge }) {
            console.log("15 action.payload.edges", action.payload.edges);
            //.sort((a: ActivityNode, b: ActivityNode) => a.node.activityId > b.node.activityId ? -1 : 1)
            // state.activityList = [...state.activityList!, ...action.payload.edges!];
            let arrayForSort = ([...state.activityList!, ...action.payload.edges!]).sort((a: ActivityNode, b: ActivityNode) => a.node.activityId > b.node.activityId ? -1 : 1);
            state.activityList = arrayForSort;
        },
        deleteHaberler(state, action: { payload: [] }) {
            state.activityList = [];
        }
    }
});

export const {
    setHaberler,
    deleteHaberler
} = haberlerSlice.actions;

export default haberlerSlice.reducer;